import { Role } from '../../Helpers/AuthorizationDataProvider';
import { Rating } from '../../Helpers/useScoreHelper';

export enum ContactStatus {
  Pending = 'Pending',
  ResolveRequest = 'ResolveRequest',
  Rejected = 'Rejected',
  SeeChat = 'SeeChat',
  SendRequest = 'SendRequest',
};

export interface UserProfileResponse {
  [key: string]: any
  currentPosition?: string
  education: string[]
  firstName: string
  imageId: string
  introduction?: string
	isDeleted: boolean
  isReachableByCall: boolean
  isReachableByText: boolean
  languages?: string[]
  lastName: string
  location?: string
  pronouns?: 'she_her' | 'he_him' | 'they_them'
  researchAreas?: string[]
  role: Role
  title?: 'ms' | 'mrs' | 'mr' | 'dr'
  workExperience: string[]
}
export interface UserProfileModel {
  [key: string]: any
  currentPosition?: string
	education: string[]
	firstName: string
  imageId: string
  introduction?: string
	languages?: string[]
	lastName: string
	location?: string
	mentoringScopes: string[]
  name: string
  pronouns?: 'she_her' | 'he_him' | 'they_them'
  researchAreas?: string[]
  role: Role
  title?: 'ms' | 'mrs' | 'mr' | 'dr'
  workExperience: string[]
}

export interface UserProfileUpdateModel {
  currentPosition: string
  firstName: string
  introduction: string
  languages: string[]
  lastName: string
  location: string
  researchAreas: string[]
}

export interface ContactStatusResponse {
  communicationStatus: ContactStatus
  rocketRoomId: string
}

export interface UserRatingResponse {
	averageScore: number
	count: number
	ratings: RatingResponse[]
}

interface RatingResponse {
	feedback: string
	ratedAt: string
	score: Rating
	user: {
		firstName: string
		imageId: string
		isActive: boolean
		isDeleted: boolean
		lastName: string
		location: string
		reinvite: string
		rocketUserId: string
		role: Role
		userId: string
	}
}

export interface Review {
	feedback: string
	rating: Rating
	reviewer: {
		imageId: string
		isDeleted: boolean
		name: string
		userId: string
	}
}